import { useChangePasswordMutation } from './useChangePasswordMutation';
import { useForgotPasswordMutation } from './useForgotPasswordMutation';
import { useLoginMutation } from './useLoginMutation';
import { useResetPasswordMutation } from './useResetPasswordMutation';
import { useResetPasswordWithTokenMutation } from './useResetPasswordWithTokenMutation';

export const useAuthMutations = () => {
    const login = useLoginMutation();
    const forgotPassword = useForgotPasswordMutation();
    const resetPasswordWithToken = useResetPasswordWithTokenMutation();
    const resetPassword = useResetPasswordMutation();
    const changePassword = useChangePasswordMutation();

    return {
        login: login,
        forgotPassword: forgotPassword,
        resetPassword: resetPassword,
        resetPasswordWithToken: resetPasswordWithToken,
        changePassword: changePassword,
        isLoading:
            login.isLoading ||
            forgotPassword.isLoading ||
            resetPassword.isLoading ||
            resetPasswordWithToken.isLoading ||
            changePassword.isLoading,
        error:
            login.mutate.error ||
            forgotPassword.mutate.error ||
            resetPassword.mutate.error ||
            resetPasswordWithToken.mutate.error ||
            changePassword.mutate.error,
    };
};
